import ES from './es';
import EN from './en';

const collections = {
    ES,
    EN
};

export default collections;
